import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import {
  Grid, Button, Header, Loader, Segment, Confirm
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { useProductsAndQuotation } from '../helpers/hooks';
import ProductList from './ProductList';
import Stepper from './Stepper';

const Checkout = ({
  history: { push },
  match: { params },
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { products, setProducts } = useProductsAndQuotation(params.id);

  const [confirm, isConfirmed] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  const show = () => setOpen(true);
  const handleCancel = () => {
    setOpen(false);
    isConfirmed(false);
  };
  const handleConfirm = () => {
    isConfirmed(true);
    setOpen(false);
    submitCheckout();
  };

  if (products === null) {
    push('/');
  }

  if (products && products.size === 0) {
    push(`/quotation/${params.id}`);
  }

  if (!products || products.size === 0) {
    return <Loader active inline="centered" />;
  }

  const submitCheckout = () => {
    setIsSubmitting(true);
    axios.patch(`/api/v1/quotations/${params.id}/`, { is_done: true })
    .then(() => {
      setIsSubmitting(false);
      push(`/quotation/${params.id}/thanks`);
    })
    .catch(() => {
      setIsSubmitting(false);
    });
  };

  return (
    <>
      <Stepper step={3} />

      <Header as="h3">{t('Round 3')}</Header>

      <Header as="h2">
        {t('Remember to add ALL the products you want to sell:')}
      </Header>

      <ProductList products={products} setProducts={setProducts} />

      <Segment className="tips" attached="bottom">
        <p>
          {t(
            'Please make sure to add all items at this stage to receive an accurate quote.'
          )}
        </p>

        <dl style={{ marginBottom: '24px' }}>
          <dt style={{ fontWeight: 600, fontSize: '14px' }}>{t('Sale of games')}</dt>
          <dt>{t('Example: I have 2 games to sell')}</dt>
          <dt>
            <div>- {t('Game The Last Of Us - PS3')}</div>
            <div>- {t('Game God Of War - PS4')}</div>
          </dt>
          <dd className="correct" style={{ marginBottom: 0 }}>
            {t('Add them separately using the button')} <u>{t('+ Add new product')}</u>.
          </dd>
        </dl>

        <dl style={{ marginBottom: 0 }}>
          <dt style={{ fontWeight: 600, fontSize: '14px' }}>{t('Sale of console + games')}</dt>
          <dt>{t('Example: I have a playstation 4 + 1 game to sell')}</dt>
          <dt>
            <div>- {t('Console Playstation 4 Slim 500GB - Sony')}</div>
            <div>- {t('Game God Of War - PS4')}</div>
          </dt>
          <dd className="correct" style={{ marginBottom: 0 }}>
            {t('Add them separately using the button')} <u>{t('+ Add new product')}</u>.
          </dd>
        </dl>
      </Segment>

      <Button
        id="add-another"
        content={t('+ Add new product')}
        className="add-another"
        primary
        fluid
        disabled={isSubmitting}
        onClick={() => push(`/quotation/${params.id}`)}
      />

      <Grid className="buttons-pair" columns={2} stackable reversed="computer tablet">
        <Grid.Column>
          <Button
            id="finish"
            content={t('Finish quotation')}
            fluid
            color="green"
            className={`${!confirm ? 'waiting-confirmation' : ''}`}
            loading={isSubmitting}
            disabled={products.size === 0 || isSubmitting}
            onClick={() => setOpen(true)}
          />
        </Grid.Column>
        <Grid.Column>
          <Button
            id="back"
            type="button"
            content={t('Back')}
            secondary
            fluid
            disabled={isSubmitting}
            onClick={() => push(`/quotation/${params.id}`)}
          />
        </Grid.Column>
      </Grid>

      <Confirm
          className='confirm-modal-checkout'
          open={open}
          content={t('Are you sure you want to finish the quotation?')}
          confirmButton={t('Yes')}
          cancelButton={t('No')}
          size="small"
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        />
    </>
  );
};

export default withRouter(Checkout);
